export default {
    props: ['activetab', 'ean', 'token', 'url'],
    data: () => {
        return {
            eans: [],
            results: [],
            selectedEan: ''
        }
    },
    mounted() {

        window.clearTabs = this.clearTabs;
        $(document).on('hidden.bs.modal', function (event) {
            if(event.target.id === "sellers-overlay") {
                $("#intellyholder-controls").css('display','block');
                $('#sellers-overlay').removeClass('opened');
                window.clearTabs();
            }
        });

        this.loaderContent();

    },
    methods : {
        selectTab() {
            this.selectedEan = document.getElementById('select-intelly').value;
            let selectField = document.getElementById('select-intelly');
            if(this.selectedEan !== '') {
                $("#intellyholder-controls").css('display','none');
                $('#sellers-overlay').addClass('opened');
                selectField.classList.remove("invalid");
            } else {
                selectField.classList.add("invalid");
                selectField.focus();
            }
        },
        splitEANs: function () {

            let ean = this.ean;

            if(ean === '' || ean === undefined){
                return false;
            }

            let eans = ean.split(',');
            let index = 0;
            for(let e of eans){
                if(e === ''){
                    eans.splice(index, 1);
                }
                index++;
            }

            return eans;
        },
        loaderContent() {

            this.eans = this.splitEANs();
            let auth = {
                token: this.token,
                api: this.url,
                auth: 'auth',
                products: 'product',
            }

            const promisses = [];

            for (let ean of this.eans) {

                let promise = new Promise((resolve, reject) => {
                    let sellerProducts = [];
                    let infos = {};

                    jQuery.ajax({
                        headers: { "Authorization": auth.token },
                        type: 'GET',
                        url: auth.api + "/" + auth.products + "/" + ean,
                        timeout: 20000,
                        dataType: "json",
                    }).done((result) => {
                        infos.ean = result.data.ean;
                        infos.name = result.data.name;

                        for (const products of result.data.offers) {
                            if (products.url !== ""){
                                sellerProducts.push(products);
                            }
                        }

                        resolve({'infos' : infos, 'sellers' : sellerProducts});
                    }).fail((request, status) => {
                        reject("Error: " + status);
                    });
                });

                promisses.push(promise);
            }

            if(promisses.length > 0) {
                window.pushResult = this.pushResult;
                Promise.all(promisses).then(function(values) {
                    window.pushResult(values);
                }).catch(error => {
                   this.eans = [];
                });
            }

        },
        pushResult(values) {
            this.results = values;
            $('#sellers-link').removeClass('loading');

            if(this.results.length === 1) {
                this.selectedEan = this.results[0].infos.ean;
                $("#intellyholder-controls").css('display','none');
                $('#sellers-overlay').addClass('opened');
            }
        },
        clearTabs() {
            this.selectedEan = '';
            document.getElementById('select-intelly').value = '';
            console.log('close Tab');
        }
    }
}
